import React from 'react';
import PropTypes from 'prop-types';
import {  useNavigate } from 'react-router-dom';
import config from '../../config';
import './styles.scss';


Button.propTypes = {
    title: PropTypes.string,
    path: PropTypes.string,
};

function Button(props) {
    const { title, path, onClick, btnclass, disabled } = props;
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        if (path) {
            navigate(config.root +path);
        }
    }
    return (
        <button className={`btn_yellow ${btnclass}`}
            onClick={()=>handleClick()} disabled={disabled}>
            {title} 
        </button>
    );
}

export default Button;